import React, { useCallback, useEffect, useRef } from 'react';
import { WarningCircleFillIcon } from '@chegg-ui/horizon-icons';
import { CheckCircleFillIcon } from '@chegg-ui/horizon-icons';
import { NotificationTypes } from '@chegg-ui/notification-banner';
import { colors } from '@chegg-ui/theme';
import { spacing } from '@chegg-ui/theme';
import { abortPolling } from '@chegg/one-auth-sdk';
import { FlexWrapperSC, LinkSC, LogoSC, MarginBottomSC, TypographySC } from "../../../common/styles/common.styles";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { startOrchestrator } from "../../../store/orchestrator";
import { handleToastMessage } from "../../../store/orchestrator/utils/orchestrator.utils";
import { changeRoute } from "../../../store/slices/router";
// Note! : do not add alias@ it does not compile in auth page
import { setIsToastOpen } from "../../../store/slices/errorModal";
import { FooterSC } from "../FeedbackModals.styles";
import { getNotificationLabels } from "./notification.utils";
export var Notification = function Notification(props) {
  var _useAppSelector;
  var variant = props.variant;
  /* istanbul ignore next */
  var _ref = (_useAppSelector = useAppSelector(function (state) {
      return state.error.toast;
    })) !== null && _useAppSelector !== void 0 ? _useAppSelector : {},
    disappearAfterMs = _ref.disappearAfterMs;
  var dispatch = useAppDispatch();
  var timeoutRef = useRef(undefined);
  useEffect(function () {
    /* istanbul ignore next */
    if (disappearAfterMs && disappearAfterMs > 0) {
      timeoutRef.current = setTimeout(function () {
        dispatch(setIsToastOpen({
          isOpen: false,
          type: NotificationTypes.Information
        }));
        dispatch(startOrchestrator());
      }, disappearAfterMs);
    }
    /* istanbul ignore next */
    (function () {
      clearTimeout(timeoutRef.current);
    });
  }, [disappearAfterMs]);
  var onResendCb = function onResendCb() {
    handleToastMessage(dispatch, 'push_sent');
    abortPolling();
    // Note: when the banner disappears, the flow in redirected to qr page.
    // the redirect is handled in the useEffect and not here, because it must occurs
    // synchronously after the banner has been disappeared
  };
  var onLinkClickCb = useCallback(function () {
    abortPolling();
    dispatch(changeRoute('/'));
  }, [dispatch]);
  var _getNotificationLabel = getNotificationLabels(variant),
    title = _getNotificationLabel.title,
    _getNotificationLabel2 = _getNotificationLabel.body,
    body = _getNotificationLabel2 === void 0 ? '' : _getNotificationLabel2,
    _getNotificationLabel3 = _getNotificationLabel.footerTextPart_1,
    footerTextPart_1 = _getNotificationLabel3 === void 0 ? '' : _getNotificationLabel3,
    footerResendLink = _getNotificationLabel.footerResendLink,
    footerTextPart_2 = _getNotificationLabel.footerTextPart_2,
    footerLinkNavigation = _getNotificationLabel.footerLinkNavigation,
    dataTestId = _getNotificationLabel.dataTestId;
  return /*#__PURE__*/React.createElement(FlexWrapperSC, {
    "data-test": "notification_modal"
  }, /*#__PURE__*/React.createElement(LogoSC, null, renderIcon()), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px12
  }, /*#__PURE__*/React.createElement(TypographySC, {
    variant: "h2",
    variantType: "bold"
  }, title)), renderBody(), renderFooter());
  function renderIcon() {
    if (variant === 'notification_sent') {
      return /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
        "data-test": "notification_success",
        size: "large",
        color: colors.orange700
      });
    } else {
      return /*#__PURE__*/React.createElement(WarningCircleFillIcon, {
        "data-test": "notification_error",
        size: "large",
        color: colors.red700
      });
    }
  }
  function renderBody() {
    if (variant !== 'os_push_declined') {
      return null;
    }
    return /*#__PURE__*/React.createElement(TypographySC, {
      variant: "body1",
      variantType: "paragraph",
      "data-test": "error_notification_subtitle"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: body
      }
    }));
  }
  function renderFooter() {
    switch (variant) {
      case 'notification_sent':
        {
          return /*#__PURE__*/React.createElement(FooterSC, {
            variant: "caption",
            variantType: "normal",
            "data-test": dataTestId
          }, /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: footerTextPart_1
            }
          }), ' ', /*#__PURE__*/React.createElement(LinkSC, {
            hasButtonBehavior: true,
            "data-test": "push_sent_resend_link",
            "data-rio-target": "push_sent_retry_link",
            onClick: onResendCb
          }, footerResendLink), footerTextPart_2, /*#__PURE__*/React.createElement(LinkSC, {
            hasButtonBehavior: true,
            "data-test": "push_sent_navigate_link",
            "data-rio-target": "push_sent_navigate_link",
            onClick: onLinkClickCb
          }, footerLinkNavigation));
        }
      case 'app_push_declined':
        {
          return /*#__PURE__*/React.createElement(FooterSC, {
            variant: "caption",
            variantType: "normal",
            "data-test": dataTestId
          }, /*#__PURE__*/React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: footerTextPart_1
            }
          }), /*#__PURE__*/React.createElement(LinkSC, {
            hasButtonBehavior: true,
            "data-test": "app_push_declined_navigate_link",
            "data-rio-target": "app_push_declined_navigate_link",
            onClick: onLinkClickCb
          }));
        }
      case 'os_push_declined':
        {
          return /*#__PURE__*/React.createElement(FooterSC, {
            variant: "body1",
            variantType: "normal",
            "data-test": dataTestId
          }, /*#__PURE__*/React.createElement(LinkSC, {
            hasButtonBehavior: true,
            "data-test": "os_push_declined_navigate_link",
            "data-rio-target": "os_push_declined_navigate_link",
            onClick: onLinkClickCb
          }, footerLinkNavigation));
        }
    }
  }
};